import { LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SlhCoreLoadingBar } from "@slhuicore/loading-bar";
import { ClassInfo } from "lit/directives/class-map.js";
import { style } from "./assets/loading-bar.generated-style";

/**
 * Progress indicators inform users about the status of ongoing processes,
 * such as loading an app, submitting a form, or saving updates.
 * They communicate an app’s state and indicate available actions,
 * such as whether users can navigate away from the current screen.
 *
 * @CustomElement slh-loading-bar
 *
 * @cssprop --slh-color-neutral-shade-20 - Background color.
 * @cssprop --slh-color-primary - Progress bar primary background color.
 * @cssprop --slh-color-success - Progress bar success background color.
 * @cssprop --slh-color-info - Progress bar info background color.
 * @cssprop --slh-color-warning - Progress bar warning background color.
 * @cssprop --slh-color-error - Progress bar error background color.
 */
@customElement("slh-loading-bar")
export default class SlhLoadingBar extends SlhCoreLoadingBar(LitElement) {
  /**
   * Adds primary styling
   */
  @property({
    type: Boolean,
  })
  primary: boolean = false;

  /**
   * Adds success styling
   */
  @property({
    type: Boolean,
  })
  success: boolean = false;

  /**
   * Adds info styling
   */
  @property({
    type: Boolean,
  })
  info: boolean = false;

  /**
   * Adds warning styling
   */
  @property({
    type: Boolean,
  })
  warning: boolean = false;

  /**
   * Adds error styling
   */
  @property({
    type: Boolean,
  })
  error: boolean = false;

  static styles = style;

  /**
   *
   * @returns {ClassInfo} ClassList
   */
  renderClasses(): ClassInfo {
    return {
      indeterminate: this.indeterminate === true,
      primary: this.primary,
      success: this.success,
      info: this.info,
      warning: this.warning,
      error: this.error,
    };
  }
}
